import React, { Component } from "react";
import ProductTile from "../ProductTile/ProductTile";
import Pagination from "../Pagination/Pagination";
import axios from "axios";
import lodashIsEqual from "lodash.isequal";
import Cookies from "js-cookie";
import { connectHits } from "react-instantsearch-dom";
import "./SearchResults.scss";

class SearchResults extends Component {
  constructor(props) {
    super(props);

    this.state = {
      availability: [],
      storeId: Cookies.get("OW_STORE_NAME") || "W301",
      deliveryPostcode: Cookies.get("OW_DELIVER_POSTCODE") || "3000",
    };
  }

  componentDidMount() {
    this.fetchAvailability();
  }

  componentDidUpdate(prevProps) {
    if (!lodashIsEqual(this.props.hits, prevProps.hits)) {
      this.fetchAvailability();
    }
  }

  fetchAvailability() {
    const skusToFetch = this.props.hits.map((hit) => hit.sku);
    const { storeId, deliveryPostcode } = this.state;

    if (skusToFetch.length > 0) {
      axios.get(`/catalogue-app/api/availabilities/summary/store/${storeId}/postcode/${deliveryPostcode}?partNumbers=${skusToFetch.join("|")}`)
        .then((response) => {
          if(typeof response.data === 'object'){
            this.setState({ availability: response.data });
          }
        });
    }
  }

  render() {
    const { hits } = this.props;
    const { availability } = this.state;

    return (
      <div id={"products-container"}>
        <div className={"search-results ow-tile-grid"}>
          {hits.map((hit) => {
            const itemAvailability = availability.find(
              (item) => item.sku === hit.sku
            );
            const isAvailable = itemAvailability
              ? itemAvailability.rangedOnline
              : false;
            return (
              <div className={"ow-tile-grid__item"} key={hit.sku}>
                <ProductTile {...hit} available={isAvailable} />
              </div>
            );
          })}
        </div>
        <Pagination />
      </div>
    );
  }
}

export default connectHits(SearchResults);
